import { ACTION_TYPES } from './action_types';
export function updateAnalysisPeriscope(request) {
    return {
        data: request,
        type: ACTION_TYPES.UPDATE_ANALYSIS_PERISCOPE
    };
}
export function updatePeriscope(request) {
    return {
        data: request,
        type: ACTION_TYPES.UPDATE_PERISCOPE
    };
}
export function updatePeriscopeInfo(request) {
    return {
        data: request,
        type: ACTION_TYPES.UPDATE_PERISCOPE_INFO
    };
}
